import RewardBadge from '@/components/Icon/CustomIcons/RewardBadge.svg'
import Text from '../Text'
import {
  DeviceLimits,
  DynamicYearlyProgramRewards,
} from '@/types/programs-new/programs-new'
import { useMemo } from 'react'
import NumberFlow from '@number-flow/react'
import {
  calculateDynamicRewardCategoryTotals,
  SelectedDeviceCounts,
} from './program-rewards-utils'

export default function DynamicProgramRewardsCard({
  rewardsByCategory,
  devicesSelected,
  rewardDeviceLimits,
}: {
  rewardsByCategory: DynamicYearlyProgramRewards | null
  devicesSelected: SelectedDeviceCounts
  rewardDeviceLimits: DeviceLimits | null
}) {
  if (!rewardsByCategory) {
    return null
  }
  const rewardItems = useMemo(
    () =>
      calculateDynamicRewardCategoryTotals(
        rewardsByCategory,
        devicesSelected,
        rewardDeviceLimits,
      ),
    [rewardsByCategory, devicesSelected],
  )

  // Only show 2 reward items here to keep the UI clean
  return (
    <div className="flex flex-row items-center gap-4 border border-solid p-4 rounded-md border-themed-grey-200 h-fit w-full md:max-w-md">
      {rewardItems.slice(0, 2).map((item, index, all) => (
        <div key={index} className="contents">
          {item && (
            <>
              {index > 0 && all.length > 1 && (
                <div className="w-[1px] h-20 bg-themed-grey-200" />
              )}
              <RewardCardItem
                key={item.label}
                label={item.label}
                currentTotal={item.currentTotal}
                suffix={item.suffix}
              />
            </>
          )}
        </div>
      ))}
    </div>
  )
}

function RewardCardItem({
  label,
  currentTotal,
  suffix,
}: {
  label: string
  currentTotal: number
  suffix: string
}) {
  return (
    <div className="w-full flex-grow-1 h-full flex flex-col gap-1 justify-center items-center flex-grow">
      <img
        src={RewardBadge}
        className="size-6 rounded-full fill-base-success bg-base-green-100"
      />
      <Text className="text-center" variant="body2">
        {label}
      </Text>
      <Text className="text-themed-green-900 text-center h-6">
        <span className="eased-value">
          <NumberFlow value={currentTotal} prefix={'$'} suffix={` ${suffix}`} />
        </span>
      </Text>
    </div>
  )
}
